import React from "react";
import { Col, Row } from "react-bootstrap";

const Dashboard = () => {
  return (
    <div className="p-4">
      <Row>
        <Col className="d-flex align-items-end">
          <h1 style={styles.pageTitle}>Dashboard</h1>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;

const styles = {
  pageTitle: {
    textAlign: "left",
    color: "#0d6efd",
  },
};
